import { MAX_COLUMNS } from './TableSize/constants';
import { ITableCoordinates } from './TableSize/TableSize.types';

export const DEFAULT_CELL: ITableCoordinates = { x: 0, y: 0 };

export const DEFAULT_TABLE_WIDTH = 740;
export const MIN_CELL_WIDTH = DEFAULT_TABLE_WIDTH / MAX_COLUMNS;
export const MIN_CELL_HEIGHT = 60;
